import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { guid } from '@progress/kendo-angular-common';
import { DataHandlerService } from 'src/app/Services/data-handler.service';
import { IUserData } from 'src/app/Models/IUserData';
import { SUBJECT_ID_PATH_KEY, SUBJECT_LECTURER_PATH_KEY } from 'src/app/Constants/request-path-keys';

@Component({
  selector: 'app-subject-lecturer',
  templateUrl: './subject-lecturer.component.html',
  styleUrls: ['./subject-lecturer.component.scss']
})
export class SubjectLecturerComponent implements OnInit {
  @Input() subjectId: number;
  @Input() subjectName: string;

  @Output() closeEmit = new EventEmitter();

  lecturers: Array<IUserData> = [];
  removeLecturer: IUserData;
  modalSpinnerId: string = guid();

  constructor(
    private dataHandlerService: DataHandlerService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.getLecturersBySubjectId();
  }

  getLecturersBySubjectId() {
    this.dataHandlerService.getDataWithModalSpinner(
      `${SUBJECT_LECTURER_PATH_KEY}/${SUBJECT_ID_PATH_KEY}/${this.subjectId}/${true}`,
      this.modalSpinnerId
    ).then(response => {
      this.lecturers = response;
    });
  }

  // (click)="changeCheckboxValue($event, !lecturer.isBelongToCurrentSubject, lecturer, confirmremove)"

  changeCheckboxValue(event, isBelongToCurrentSubject: boolean, lecturer: IUserData, content: any): void {
    if (!isBelongToCurrentSubject) {
      event.preventDefault();
      this.removeLecturer = lecturer;
      this.modalService.open(content).result;
    } else {
      this.submit(isBelongToCurrentSubject, lecturer.id);
    }
  }

  submit(isBelongToCurrentSubject: boolean, lecturerId: number): void {
    const body = {
      create: isBelongToCurrentSubject,
      subjectId: this.subjectId,
      lecturerId: lecturerId
    };

    this.dataHandlerService.createData(body, SUBJECT_LECTURER_PATH_KEY, null).then(() => {
      this.removeLecturer = null;
    });
  }

}


